import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddOutstationComponent } from './add-outstation/add-outstation.component';
import { ViewOutstationComponent } from './view-outstation/view-outstation.component';
import { OutstationDetailsComponent } from './outstation-details/outstation-details.component';
import { OutstationWidgetsComponent } from './outstation-widgets/outstation-widgets.component';
import { UploadOutstationComponent } from './upload-outstation/upload-outstation.component';

const routes: Routes = [
  {path: "", component: ViewOutstationComponent},
  {path: "add-outstation", component: AddOutstationComponent},
  {path: "outstation-details", component: OutstationDetailsComponent},
  {path: "upload-setup", component: UploadOutstationComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OutstationRoutingModule { }
